import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, MaskedLines, Reveal } from "../motion/Reveal";
import { approach } from "../../content/site";

export const Approach = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="approach" data-testid="approach-section" className="tc-sheet bg-[#FAFAF9] py-24 text-stone-900 sm:py-32">
      <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Eyebrow light>05 — Our approach</Eyebrow>
            <h2 className="mt-8 font-display text-3xl font-medium leading-[1.05] tracking-tight sm:text-5xl">
              <MaskedLines inView lines={["How we deliver", "technology."]} />
            </h2>
            <p className="mt-8 max-w-md text-base leading-relaxed text-stone-600">
              Every engagement follows the same disciplined rhythm, whether it is a single office network or a multi-site rollout.
            </p>
          </div>
        </div>
        <div ref={ref} className="relative lg:col-span-7">
          <div className="absolute bottom-0 left-[19px] top-0 w-px bg-stone-300" />
          <motion.div style={{ scaleY }} className="absolute bottom-0 left-[19px] top-0 w-px origin-top bg-orange-600" />
          <ol className="space-y-14">
            {approach.map(([t, d], i) => (
              <Reveal as="li" key={t} className="relative pl-16">
                <span className="absolute left-0 top-0 grid h-10 w-10 place-items-center rounded-full border border-stone-300 bg-[#FAFAF9] font-mono text-xs text-orange-700">
                  0{i + 1}
                </span>
                <p className="font-display text-2xl sm:text-3xl">{t}</p>
                <p className="mt-3 max-w-lg text-base leading-relaxed text-stone-600">{d}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
